import React from 'react';

import { Project, ProjectViewType, Timesheet } from '../types';

import { ProjectTimesheetByProjects } from './ProjectTimesheetsByProjects';
import { ProjectTimesheetByDays } from './ProjectTimesheetsByDays';
type Props = {
  viewType: ProjectViewType;
  projects: Project[];
  timesheet: Timesheet;
  showTimeEntries: boolean;
  onProjectClick: (project: Project) => void;
};

export const ProjectsTimesheets: React.FC<React.PropsWithChildren<Props>> = ({
  viewType,
  projects,
  timesheet,
  showTimeEntries,
  onProjectClick,
}) => {
  if (viewType === 'BY_DAYS') {
    return (
      <ProjectTimesheetByDays
        timesheet={timesheet}
        projects={projects}
        showProjectDistribution={showTimeEntries}
      />
    );
  } else if (viewType === 'BY_PROJECTS') {
    return (
      <ProjectTimesheetByProjects
        key={getTimesheetKey(timesheet)}
        timesheet={timesheet}
        projects={projects}
        showProjectDistribution={showTimeEntries}
        onProjectClick={onProjectClick}
      />
    );
  } else {
    return <></>;
  }
};

function getTimesheetKey(timesheet: Timesheet) {
  // Key is created to rerender ProjectTimesheetByProjects when we are creating a new Project Time Entry
  return `${timesheet.id}_${timesheet.projectTimeTracked.length}`;
}
